
import React from 'react';
import URLShare from '@opm/components/URLShare';
import RenderImg from '@op/components/RenderImg';
import { DBO_V } from '@op/utils/format';
import './index.scss';
import useIntls from '@opm/hooks/useIntls';
import { IKolData } from '@opm/pages/Hashtag/types';

export default function KolCard(props: { data: IKolData; isSelected: boolean; handleOnClick: (data: any) => void; }) {
  const { data, isSelected, handleOnClick } = props;
  const { intl } = useIntls();

  return (
    <div className={`dbom-kols-card ${isSelected ? 'selected' : ''}`} onClick={() => handleOnClick(data)}>
      <div className="dbom-kols-avatar">
        <RenderImg coverImage={data?.anchor_image} mode='image' />
      </div>
      <div className="dbom-kols-info">
        <div className="dbom-kols-title">
          <span className="dbom-kols-name">{data?.anchor_name}</span>
          <URLShare
            className="dbom-kols-card-share"
            iconClassName="dbo-feeds-btn-icon"
            url={data?.anchor_url}
            tips={`Go to the source website's personal homepage`}
          />
        </div>
        <div className="dbom-kols-summary">
          <div className="dbom-kols-summary-item">
            <div className="dbom-kols-summary-value">
              {DBO_V.reviews(data?.followers_number)}
            </div>
            <div className="dbom-kols-summary-label">
              {intl('Followers')}
            </div>
          </div>
          <div className="dbom-kols-summary-item">
            <div className="dbom-kols-summary-value">
              {DBO_V.reviews(data?.likes_number)}
            </div>
            <div className="dbom-kols-summary-label">
              {intl('Likes')}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
